import Button from "@/components/Button";
import { useTranslation } from "react-i18next";
import { trackEvent } from "@/lib/amplitude";
import { useEffect, useRef } from "react";

export default function CouponRedeemed() {
  const { t } = useTranslation();
  const hasTrackedPageView = useRef(false);
  const placeRef = window.localStorage.getItem("placeRef");

  useEffect(() => {
    if (!hasTrackedPageView.current) {
      hasTrackedPageView.current = true;
      trackEvent("coupon_redeemed_page_viewed", { placeRef });
    }
  }, []);

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <div className="mx-auto flex min-h-[100dvh] w-full max-w-md grow flex-col px-6">
        <div className="flex grow flex-col items-center justify-center pb-20">
          <div className="flex w-full animate-slideUp flex-col items-center gap-8">
            {/* Success Icon */}
            <div className="relative">
              <div className="flex h-24 w-24 items-center justify-center rounded-full bg-green-500/20">
                <div className="flex h-20 w-20 items-center justify-center rounded-full bg-green-500">
                  <svg
                    className="h-12 w-12 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={3}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
              </div>
            </div>

            {/* Main Content */}
            <div className="flex flex-col items-center gap-4">
              <h1 className="text-center text-3xl font-bold text-foreground">
                {t("coupon.redeemed.title")}
              </h1>
              {/* <p className="text-center text-gray"> */}
              {/*   {t("coupon.redeemed.subtitle")} */}
              {/* </p> */}
            </div>

            {/* Info Card */}
            <div className="w-full rounded-3xl border border-light-gray bg-medium-gray p-8">
              <div className="space-y-4">
                <h2 className="text-center text-xl font-semibold text-foreground">
                  {t("coupon.redeemed.appPromo.title")}
                </h2>
                <p className="text-center text-sm leading-relaxed text-white">
                  {t("coupon.redeemed.appPromo.message")}
                </p>
              </div>

              <div className="mt-6 space-y-3">
                <div className="flex items-center gap-3 rounded-xl bg-light-gray/50 p-4 shadow-md shadow-dark-gray">
                  <span className="text-2xl">🎬</span>
                  <div className="flex-1">
                    <p className="text-sm text-foreground">
                      {t("coupon.redeemed.appPromo.features.videos")}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3 rounded-xl bg-light-gray/50 p-4 shadow-md shadow-dark-gray">
                  <span className="text-2xl">🏆</span>
                  <div className="flex-1">
                    <p className="text-sm text-foreground">
                      {t("coupon.redeemed.appPromo.features.rewards")}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3 rounded-xl bg-light-gray/50 p-4 shadow-md shadow-dark-gray">
                  <span className="text-2xl">🌟</span>
                  <div className="flex-1">
                    <p className="text-sm text-foreground">
                      {t("coupon.redeemed.appPromo.features.discover")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* CTA Button */}
            <Button
              onPress={() => {
                trackEvent("app_download_clicked", {
                  placeRef,
                  source: "coupon_redeemed_page",
                });
                window.open("https://onelink.to/behnx6");
              }}
              className="w-full"
            >
              {t("conclusion.button")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
